import type { IEvent } from '@/components/calendar';
import type { DeleteBlockedTimeVariables } from '@/features/scheduling';

export function createDeleteEventHandler(deps: {
  deleteAppointmentAsync: (id: string) => Promise<unknown>;
  deleteBlockedTimeAsync: (
    variables: DeleteBlockedTimeVariables
  ) => Promise<unknown>;
}): (event: IEvent) => Promise<void> {
  return async (event) => {
    if (event.metadata?.type === 'blocked-time') {
      if (event.metadata.importedFromGoogle || event.metadata.calendarSourceId)
        return;
      const isRecurring = !!event.metadata.rrule;
      const originalStart = event.metadata.originalStart as
        | string
        | null
        | undefined;
      await deps.deleteBlockedTimeAsync({
        id: String(event.metadata.blockedTimeId ?? event.id),
        scope: isRecurring ? 'this' : 'all',
        ...(isRecurring && originalStart ? { originalStart } : {}),
      });
      return;
    }
    await deps.deleteAppointmentAsync(String(event.id));
  };
}
